import { setRoute } from '../../routes/actions/set';

export function request(id) {
    return (dispatch, getState) => {
        const state = getState();

        // if (id == state.routes.getIn([ 'audits', 'value' ]) || id === state.routes.getIn([ '*global:audits', 'value' ])) {
        //     dispatch(setRoute('audits'));
        // }

        dispatch({
            type: 'AUDITS_CLOSE_REQUEST',
            id,
        });
    };
}
